import { useFlags } from 'launchdarkly-react-client-sdk';

export enum DropdownItemsTypes {
  pdf = 'pdf',
  email = 'email',
  moreInfo = 'moreInfo',
  download = 'download',
  viewLink = 'viewLink',
  delete = 'delete',
  ai = 'ai',
  favorites = 'favorites',
  getLink = 'getLink',
  goToCategory = 'goToCategory',
  createPresentation = 'createPresentation',
  addToPresentation = 'addToPresentation',
  print = 'print'
}

type ItemType = keyof typeof DropdownItemsTypes;

export type DropdownItemsType = ItemType[];

export const useResourcesDropdownItems = (hiddenItems: string[] = []) => {
  const flags = useFlags();

  const resourcesItems: DropdownItemsType = [
    DropdownItemsTypes.pdf,
    DropdownItemsTypes.email,
    DropdownItemsTypes.favorites,
    DropdownItemsTypes.download,
    DropdownItemsTypes.ai,
    ...(flags?.localPrinter ? [DropdownItemsTypes.print] : []),
    DropdownItemsTypes.getLink,
    DropdownItemsTypes.moreInfo,
    DropdownItemsTypes.delete,
    ...(flags?.myPresentations
      ? [
          DropdownItemsTypes.createPresentation,
          DropdownItemsTypes.addToPresentation
        ]
      : [])
  ];

  // If hiddenItems are provided, filter based on that
  const filteredItems = hiddenItems
    ? resourcesItems.filter(item => !hiddenItems.includes(item))
    : resourcesItems;

  return { resourcesItems: filteredItems };
};
